import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

export const useHolidayNavigate = () => {
  const navigate = useNavigate();

  return {
    pageNavigate: (page?: string, id?: string) => {
      if (page && id) {
        navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.holidayManager}&id=${id}&page=${page}`);
        return;
      }
      navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.holidayManager}`);
    },
  };
};
